import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderListComponent } from './order-list.component';
import { HeaderModule } from 'src/app/components/header/header.module';
import { MenuModule } from 'src/app/components/menu/menu.module';
import { MenuFooterModule } from 'src/app/components/menu-footer/menu-footer.module';
import { HeaderInSectionModule } from 'src/app/components/header-in-section/header-in-section.module';
import { OrderBodyModule } from './body-order-list/body-order-list.module';
import { ModalModule } from 'src/app/components/dialogs/modal.module';

@NgModule({
  declarations: [
    OrderListComponent
  ],
  imports: [
    CommonModule,
    HeaderModule,
    MenuModule,
    MenuFooterModule,
    HeaderInSectionModule,
    OrderBodyModule,
    ModalModule
  ]
})
export class OrderListModule { }
